export function setupPathCourses() {
  let courseCatalog = document.querySelector('#catalog-courses');
  let isLearningPath = document.querySelector('.sj-page-detail-path') || document.querySelector('.sj-page-path');

  if (isLearningPath) {
    /** Move course catalog to grid container */
    let catalogContainer = document.querySelector('.row.sj-courseboxes-v2 > .columns') || document.querySelector('#catalog-content');
    catalogContainer.prepend(courseCatalog);
    document.querySelector('.columns > .catalog-center-width') && document.querySelector('.columns > .catalog-center-width').remove();

    /** Create learning path course status markers */
    let courseboxes = document.querySelectorAll('a.coursebox-container.course');
    let setNextModule = true;
    courseboxes.forEach((course, i) => {
      let pathMarker = document.createElement('div');
      pathMarker.classList.add('as-learning-path__marker');
      i === courseboxes.length - 1 && pathMarker.classList.add('as-learning-path__marker--last');

      let courseURL = course.getAttribute('href');
      let completionStatus = course.getAttribute('data-course-status');
      let pathMarkerBadge = "https://astronomer.github.io/academy-theme/dist/icons/circle.svg";
      let pathMarkerMessage = ``;

      if (completionStatus === 'complete') {
        pathMarkerBadge = "https://astronomer.github.io/academy-theme/dist/icons/check-circle-green.svg";
        pathMarkerMessage = `
          <p>You completed this module.</p>
        `
      }

      if (completionStatus === "registered") {
        pathMarkerBadge = "https://astronomer.github.io/academy-theme/dist/icons/pie.svg";
        pathMarkerMessage = `
          <p>You started this module but have not yet completed it.</p>
          <a href="${courseURL}" class="as-button">Resume Module</a>
        `
      }

      if (i === 0 && completionStatus === "unregistered") {
        pathMarkerBadge = "https://astronomer.github.io/academy-theme/dist/icons/arrow-circle-right.svg";
        pathMarkerMessage = `
          <p>This is the first module in this learning path.</p>
          <a href=${courseURL} class="as-button">Start Module</a>
        `;
        setNextModule = false;
      }

      // if (i !== 0 && completionStatus === "unregistered" && setNextModule) {
      //   pathMarkerBadge = "https://astronomer.github.io/academy-theme/dist/icons/arrow-circle-right.svg";
      //   pathMarkerMessage = `
      //     <p>This is the next module in this learning path.</p>
      //     <a href=${courseURL} class="as-button">Start Module</a>
      //   `;
      //   setNextModule = false;
      // }


      pathMarker.innerHTML = `
        <div class="as-path-marker__inner">
          <div class="as-path-marker__status-icon">
            <img src="${pathMarkerBadge}" width="40" height="40" alt="" />
          </div>
          <div class="as-path-marker__text">
            ${pathMarkerMessage}
          </div>
        </div>
      `
      course.insertAdjacentElement('beforebegin', pathMarker);
    })

    let courseCount = courseboxes.length;
    courseCatalog.style.gridTemplateRows = `repeat(${courseCount}, 1fr)`;
  }
}